enum AxisStrategy {
  Default,
  Compact
}

export default AxisStrategy
